import styled, { css } from 'styled-components';
import {
    Adornment,
    AdornedInput,
    Input,
    FormHelp,
    token,
} from '@zillow/constellation';

export const StyledAdornedInput = styled(AdornedInput)`
    margin-bottom: 8px;
    
    /* 0 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.xs}px)`, css`
        width: 100%;
    `)};

    /* 480 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.lg - 1}px)`, css`
        width: 75%;
    `)};
`;

export const StyledAdornment = styled(Adornment)`
    padding-right: 4px;
`;

export const StyledInput = styled(Input)`
    color: ${token('colors.gray500')};
    opacity: 1;
`;

export const StyledFormHelp = styled(FormHelp)`
    font-weight: 600;
`;
